var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_672_5419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.58331 10.2917H6.33331V16.625H1.58331V10.2917ZM12.6666 6.33333H17.4166V16.625H12.6666V6.33333ZM7.12498 2.375H11.875V16.625H7.12498V2.375ZM3.16665 11.875V15.0417H4.74998V11.875H3.16665ZM8.70831 3.95833V15.0417H10.2916V3.95833H8.70831ZM14.25 7.91667V15.0417H15.8333V7.91667H14.25Z",
    fill: "#1B407A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_672_5419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.b27362518ba81677f557fbaa297f2c5a.svg";
export { ForwardRef as ReactComponent };